//
//
//
//
//
//

	export default {
		name: 'QuickRadio',

		props: {
			value: String
		},

		data () {
			return {
				currentValue: this.value
			}
		},

		watch: {
			currentValue(val) {
				this.$emit('input', val)
      			this.$emit('on-change', val)
			}
		}
	}



// WEBPACK FOOTER //
// ./src/components/quickRadio/quickRadio.vue